export default __webpack_public_path__ + "static/media/Hyrkanian Wicked Chaos-Clapper.90cd08e4.jpg";